import {
    notificationCancelModelUpdate,
    notificationApplyModelUpdate,
} from "../../../../actions/notification-actions"

import buildEditFormActionButtonsWidgetContainer from "../../../common/build-edit-form-action-buttons-widget-container"

export default buildEditFormActionButtonsWidgetContainer(
    notificationApplyModelUpdate,
    notificationCancelModelUpdate,
    "notifications"
)
